// import newsBbList from '../components/noticeBb/newsBbList.vue'
// import noticeBbList from '../components/noticeBb/noticeBbList.vue'
// import trainingBbList from '../components/noticeBb/trainingBbList.vue'

export default [
    { 
        path: 'noticeBb/newsBbList',
        component: resolve => require(['@/components/noticeBb/newsBbList'],resolve),
        name:'NewsBbList',
        meta:{
            // id:'602',
            node:'noticeBb',
            url:'newsBbList',
        }
    },
    { 
        path: 'noticeBb/noticeBbList',
        component: resolve => require(['@/components/noticeBb/noticeBbList'],resolve),
        name:'NoticeBbList',
        meta:{
            id:'953',
            node:'noticeBb',
            url:'noticeBbList',
        }
    },
    { 
        path: 'noticeBb/trainingBbList',
        component: resolve => require(['@/components/noticeBb/trainingBbList'],resolve),
        name:'TrainingBbList',
        meta:{
            // id:'602',
            node:'noticeBb',
            url:'trainingBbList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/noticeBb.js